import { Component, Optional, Inject, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RequestRoot, UTCDate } from 'types';
import { ValidationSeverity } from 'validation';
import { ValidationService } from '../validation/validation.service';
import { ValidationBuilder } from '../validation/validation.builder';
import { WizardContext, fetchWizardContext, AppContext } from '../control/context';
import { FeaturesImpl } from '../model/features-impl';
import { ArrayColumnSetter } from '../model/features-decl';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

export class ColumnData {
  path: string;
  fullPath: string;
  i18n_name: string;
  i18n_miss: string;
  title: string;
  setters: ArrayColumnSetter<any>[];
}

@Component({
  selector: 'i-table-editor-dialog-box',
  templateUrl: './table-editor-dialog-box.component.html',
  styleUrls: ['./table-editor-dialog-box.component.scss'],
  providers: [
    { provide: ValidationService, useClass: ValidationService },
    { provide: WizardContext, useFactory: fetchWizardContext, deps: [MAT_DIALOG_DATA] },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: ['YYYY-MM-DD'],
        },
        display: {
          dateInput: 'YYYY-MM-DD',
          monthYearLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class TableEditorDialogBoxComponent implements OnInit, AfterViewInit {
  private _columns: ColumnData[];

  rootModel: RequestRoot;
  grid: string;
  element: any;
  elementTemplate: any;
  rootPath: string;
  dateRanges: Array<{ propFrom: string; propTo: string }>;
  dialogTitle?: string;

  constructor(
    private appContext: AppContext,
    private validationService: ValidationService,
    private dialogRef: MatDialogRef<TableEditorDialogBoxComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    data: any,
    private cdRef: ChangeDetectorRef,
  ) {
    this._columns = [...data.columns];
    this.rootModel = data.rootModel;
    this.element = data.element;
    this.elementTemplate = data.elementTemplate;
    this.rootPath = data.rootPath;
    this.dialogTitle = data.dialogTitle;
  }

  get columns(): ColumnData[] {
    return this._columns;
  }

  ngOnInit(): void {
    this.dateRanges = FeaturesImpl.getArrayDateRanges(this.elementTemplate) || [];
    this.validationService.initialize(() =>
      new ValidationBuilder(this.appContext, this.rootModel.features, false)
        .validate(this.rootModel.features, UTCDate.today(new Date()))
        .getErrors(),
    );
  }

  ngAfterViewInit(): void {
    this.cdRef.detach();
    this.grid = FeaturesImpl.getArrayEditGridStyle(this.elementTemplate, window.innerWidth);
    this.cdRef.detectChanges();
    this.cdRef.reattach();
  }

  onOk(): void {
    this.validationService.finalize();
    const validationBuilder = new ValidationBuilder(this.appContext, this.rootModel.features);
    const validationResult = validationBuilder.validate(this.rootModel.features, UTCDate.today(new Date()));
    if (
      validationResult
        .getErrors()
        .some((e) => e.severity === ValidationSeverity.ERROR && this._columns.some((c) => e.path.startsWith(c.fullPath)))
    ) {
      this.appContext.getMessageBox(false)('fail.request.validate!', (x) => {});
      return;
    }
    this.dialogRef.close({ dialogResult: 'ok', element: this.element });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onWindowResize($event: any): void {
    setTimeout(() => {
      this.grid = FeaturesImpl.getArrayEditGridStyle(this.elementTemplate, $event.target.innerWidth);
    });
  }
}
